import React from "react"
import { FuneralUIProvider } from "@evertech/funeral-ui"
import { trackEvent } from "./utils/analytics"
import { BackToTop, CookieConsent } from "@evertech/funeral-ui/site"
import { StatusUIProvider } from "@evertech/status-ui"

const apiBaseUrl =
  process.env.GATSBY_MEMORIAL_API_URL ||
  "http://localhost:8010"
const useMockData = process.env.GATSBY_USE_MOCK_DATA === "true"
const analytics = { track: trackEvent }

// Shared by gatsby-browser.js and gatsby-ssr.js so the provider wraps the tree
// identically on the server and during client hydration.
// StatusUIProvider shares the same apiBaseUrl: the status endpoints live on the
// funeral API, they are just the anonymous, whitelist-exempt part of it.
export const wrapRootElement = ({ element }) => (
  <StatusUIProvider apiBaseUrl={apiBaseUrl}>
    <FuneralUIProvider
      apiBaseUrl={apiBaseUrl}
      useMockData={useMockData}
      analytics={analytics}
    >
      {element}
      <BackToTop />
      {/* Consent gate for GA4. gatsby-ssr.js boots gtag with
          analytics_storage: "denied"; accepting here flips it to "granted".
          Safe in the SSR-shared root because it renders null until an effect
          runs — see the component's hydration note. `privacyUrl` is omitted:
          the policy lives in the footer's WP data, which this root does not
          query, and a missing link degrades to a banner without one rather
          than no banner at all. */}
      <CookieConsent />
    </FuneralUIProvider>
  </StatusUIProvider>
)
